module.exports = __webpack_public_path__ + "img/logo_9.e43b03ca.png";